import { useTooltipData } from '../../../core/components/overlay-tooltip/_to-be-removed/utils.js';
import { OverlayTooltip } from '../../../core/components/overlay-tooltip/OverlayTooltip.js';
import type { Data } from '../../../core/components/overlay-tooltip/types.js';
import { isTooltipDataEmpty } from '../../../core/components/overlay-tooltip/utils.js';
import type { SeriesActionsTemplate } from '../../../core/types/series-actions-template.js';
import { useTruncationMode } from '../../hooks/useTruncationMode.js';

type SeriesData = Data['series'][number];

interface TreeMapOverlayTooltipProps {
  actionsForItem?: (
    item: SeriesData,
  ) => (() => SeriesActionsTemplate) | undefined;
}

export const TreeMapOverlayTooltip = (props: TreeMapOverlayTooltipProps) => {
  const data = useTooltipData().data;
  const truncationMode = useTruncationMode();

  if (isTooltipDataEmpty(data)) {
    return null;
  }

  const series = data.series[0];

  return (
    <OverlayTooltip truncation={truncationMode}>
      <OverlayTooltip.Header header1={data.header1} />
      <OverlayTooltip.SeriesItem
        name={series.name}
        value={series.value}
        color={series.color}
        actions={props.actionsForItem?.(series)}
      />
    </OverlayTooltip>
  );
};

TreeMapOverlayTooltip['displayName'] = 'TreeMapOverlayTooltip';
